import Backbone from 'backbone';
import _ from 'underscore';
import { CONTEXTUAL_DELIVERY_STATUS } from '@bingads-webui-campaign/recommendation-core';

import template from './adgroupVNext.pug';

export class AdGroupContextualAttributeViewVNext extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
    recommendationService,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.adgroupId = targetId;
    this.isMCC = isMCC;
    this.adgroupDeliveryStatusTitle = '';
    this.adgroupDeliveryStatus = '';
    this.eligibleStatusIcon = false;
    this.showStatusIcon = false;
    this.recommendationService = recommendationService;
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps,
      adgroupId,
      i18n,
    } = this;
    const options = this.isMCC ?
      {
        entitySet:
          deps
            .edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(recommendationAccountId))
            .AdGroups,
      } : {};

    deps.jsdata.AdGroup.findAll({
      limit: 1,
      select: ['Id', 'DeliveryStatus'],
      where: { Id: { $eq: adgroupId } },
    }, options).then((response) => {
      if (response.length && response.length > 0) {
        this.deliveryStatus = response[0].DeliveryStatus;
        this.adgroupDeliveryStatusTitle = i18n.getString('AdGroup_Delivery_Status');
        this.adgroupDeliveryStatus = _.contains(CONTEXTUAL_DELIVERY_STATUS, this.deliveryStatus) ?
          i18n.getString(`Label_DeliveryStatus_${this.deliveryStatus}`) :
          i18n.getString('Contextual_Response_Null');

        if (this.adgroupDeliveryStatus !== i18n.getString('Contextual_Response_Null')) {
          this.showStatusIcon = true;
        } else if (this.recommendationService) {
          this.recommendationService.currentActivity.trace(
            `unknown delivery status: "${this.deliveryStatus}" in adgroup contextual attribute`,
            'recommendation/unKnownDeliveryStatus'
          );
        }
        if (this.adgroupDeliveryStatus === i18n.getString('EntityStatus_Eligible')) {
          this.eligibleStatusIcon = true;
        }

        this.$el.html(template({
          i18n,
          adgroupDeliveryStatusTitle: this.adgroupDeliveryStatusTitle,
          adgroupDeliveryStatus: this.adgroupDeliveryStatus,
          showStatusIcon: this.showStatusIcon,
          eligibleStatusIcon: this.eligibleStatusIcon,
        }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
